// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"P5uOGi","withBorder":"qpTvTY","filter":"jmI9Hk"};